export default __webpack_public_path__ + "static/media/train_crash.e648222b.png";